var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbCountrySelect\">\n<ui-select class=\"lbCountrySelect_input\" ng-model=\"vm.country\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\">\n<ui-select-match placeholder=\"{{ ::vm.placeholder }}\">\n{{ $select.selected.Name }}\n</ui-select-match>\n<ui-select-choices repeat=\"item in vm.countries | filter: $select.search\">\n<span ng-bind-html=\"item.Name\"></span>\n</ui-select-choices>\n</ui-select>\n</div>";
var id1="components/lbCountrySelect/lbCountrySelect.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbCountrySelect/lbCountrySelect.html
// module id = 1034
// module chunks = 2